import { SignupInterestActionTypes } from './action-types';
export const submitSignupInterestForm = () => dispatch => {
  dispatch({
    type: SignupInterestActionTypes.SubmitForm
  });
};